module.exports = __webpack_public_path__ + "static/media/splash-tablet.abfbde75.png";